import { ICreateDepositOrderValues } from '@epi-models/containers/LoadCompanyAccount';
import { createSelector } from 'reselect';

import { CompanyAccountInfo } from '../reducers/api/transactionEstimation';

export const getCompanyAccounts = (state): ICreateDepositOrderValues[] =>
  state.apiCompanyAccounts.companyInfo.accounts;

export const getCompanyNotification = (state): boolean =>
  state.apiCompanyAccounts.showNotification;

export const getCompanyInvoicePFD = (state): boolean =>
  state.apiCompanyAccounts.isPrintInvoicePdfForTransferMoney;

export const getMainCompanyAccount = createSelector(
  getCompanyAccounts,
  (accounts: ICreateDepositOrderValues[]): ICreateDepositOrderValues => {
    return (
      (accounts || []).find(v => !v.parentAccountId) ||
      ({} as ICreateDepositOrderValues)
    );
  }
);

export const getMainAvailableBalance = createSelector(
  getMainCompanyAccount,
  account => {
    return (account as ICreateDepositOrderValues).availableBalance || 0;
  }
);

export const getCompanyInfo = (state): Partial<CompanyAccountInfo> => ({
  eInvoiceAddress: state.apiCompanyAccounts.companyInfo.eInvoiceAddress,
  operator: state.apiCompanyAccounts.companyInfo.operator
});
